import { useState } from 'react';
import { Link } from 'react-router-dom';
import { rankingManga } from '@/mocks/comics';

type RankingTab = 'popularity' | 'favorites' | 'updated';

export default function RankingSection() {
  const [activeTab, setActiveTab] = useState<RankingTab>('popularity');

  const tabs: { key: RankingTab; label: string }[] = [
    { key: 'popularity', label: '人气榜' },
    { key: 'favorites', label: '收藏榜' },
    { key: 'updated', label: '更新榜' },
  ];

  const sortedManga = [...rankingManga].sort((a, b) => {
    if (activeTab === 'popularity') return b.views - a.views;
    if (activeTab === 'favorites') return b.favorites - a.favorites;
    return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
  });

  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6 md:mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            排行榜
          </h2>
          <p className="text-sm text-foreground-500 mt-1">全网热门漫画实时排行</p>
        </div>
        <div className="flex items-center gap-1 bg-background-200/80 rounded-full p-1 w-fit">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeTab === tab.key
                  ? 'bg-primary-500 text-white'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
        {sortedManga.slice(0, 8).map((manga, index) => (
          <Link
            key={manga.id}
            to={`/comic/${manga.id}`}
            className="flex items-center gap-4 p-3 rounded-lg bg-background-50 hover:bg-background-200/50 transition-colors group cursor-pointer"
          >
            <div className="relative flex-shrink-0">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  title={`${manga.title} - 女神漫画排行榜热门精选`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className={`absolute -top-1 -left-1 w-5 h-5 flex items-center justify-center rounded-md text-[10px] font-bold text-white ${
                index < 3 ? 'bg-primary-500' : 'bg-foreground-400'
              }`}>
                {index + 1}
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                {manga.title}
              </h4>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs text-foreground-500">{manga.category}</span>
                <span className="text-xs text-foreground-400">·</span>
                <span className="text-xs text-accent-600 font-medium">{manga.rating}分</span>
              </div>
              <div className="flex items-center gap-1 mt-1">
                <i className="ri-eye-line text-foreground-400 text-[10px]"></i>
                <span className="text-xs text-foreground-500">{formatViews(manga.views)}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-6 text-center">
        <Link
          to="/ranking"
          className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer"
        >
          查看完整排行榜 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}